export const notificationOrder = [
    {
        value: 'older',
        label: 'Mais antigos'
    },
    {
        value: 'recent',
        label: 'Mais recentes'
    },
]
